import { fetchAuthenticatedJson } from './authenticatedFetch';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

export function fetchTradingSummary() {
  return fetchAuthenticatedJson('/api/admin/trading/summary');
}

export function fetchCorrectedBenchmark() {
  return fetchAuthenticatedJson('/api/admin/trading/benchmark/corrected');
}

export function fetchCorrectedBenchmarkAnalytics() {
  return fetchAuthenticatedJson('/api/admin/trading/benchmark/corrected/analytics');
}

export function fetchTradingPnlHistory() {
  return fetchAuthenticatedJson('/api/admin/trading/pnl-history');
}

export function fetchTradingPositions() {
  return fetchAuthenticatedJson('/api/admin/trading/positions');
}

export function fetchTradingPositionDetail(id) {
  return fetchAuthenticatedJson(`/api/admin/trading/positions/${id}`);
}

export function fetchTradingHistory(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/trading/history${buildQuery(filters)}`);
}

export function fetchAdminTradeExecutions() {
  return fetchAuthenticatedJson('/api/admin/trading/executions');
}

export function fetchBitunixRealExecutions(limit = 200) {
  return fetchAuthenticatedJson(`/api/admin/trading/executions/bitunix/real?limit=${encodeURIComponent(limit)}`);
}

export function fetchAdminExecutionSafety(limit = 50) {
  return fetchAuthenticatedJson(`/api/admin/trading/executions/safety?limit=${encodeURIComponent(limit)}`);
}

export function fetchBitunixRealExecutionSafety(limit = 50) {
  return fetchAuthenticatedJson(`/api/admin/trading/executions/bitunix/real/safety?limit=${encodeURIComponent(limit)}`);
}

export function fetchBitunixPrivateReadHealth() {
  return fetchAuthenticatedJson('/api/admin/trading/executions/bitunix/private-read-health');
}

export function fetchTradingAiCost() {
  return fetchAuthenticatedJson('/api/admin/trading/ai-cost');
}

export function fetchTradingConfig() {
  return fetchAuthenticatedJson('/api/admin/trading/config');
}

export function fetchTradingControl() {
  return fetchAuthenticatedJson('/api/admin/trading/control');
}

export function setTradingControl(enabled, reason) {
  return fetchAuthenticatedJson('/api/admin/trading/control', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ enabled, reason: reason || null }),
  });
}

export function fetchLegacyReconciliationPreview() {
  return fetchAuthenticatedJson('/api/admin/trading/legacy-reconciliation/preview');
}

export function applyLegacyReconciliation() {
  return fetchAuthenticatedJson('/api/admin/trading/legacy-reconciliation/apply', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
}
